/* Progressive enhancements; search, navigation and purchase forms work without JS. */
(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 990px)');
  function setup(root = document) {
    root.querySelectorAll('[data-ofj-navigation]').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const sync = () => { nav.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
      // A hidden desktop summary must never strand the navigation in a closed state.
      nav.addEventListener('toggle', () => { if (desktop.matches && !nav.open) nav.open = true; });
      nav._ofjCleanup = () => desktop.removeEventListener('change', sync);
    });
    root.querySelectorAll('[data-ofj-product-list]').forEach(list => {
      if (list.dataset.ready) return;
      list.dataset.ready = 'true';
      const items = Array.from(list.children);
      const button = document.querySelector('[data-ofj-expand="' + list.id + '"]');
      if (!button || items.length <= 10) return;
      items.slice(10).forEach(item => { item.hidden = true; });
      button.hidden = false;
      button.addEventListener('click', () => {
        items.forEach(item => { item.hidden = false; });
        button.hidden = true;
        const firstNewLink = items[10].querySelector('a');
        if (firstNewLink) firstNewLink.focus();
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-ofj-dropdown][open]').forEach(dropdown => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focused = document.activeElement;
    const inner = focused && focused.closest('[data-ofj-dropdown][open]');
    if (inner) { inner.open = false; inner.querySelector('summary').focus(); return; }
    document.querySelectorAll('[data-ofj-dropdown][open]').forEach(dropdown => { dropdown.open = false; });
    const nav = document.querySelector('[data-ofj-navigation][open]');
    if (nav && !desktop.matches) { nav.open = false; nav.querySelector('summary').focus(); }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('.ofj-quick-add')) return;
    const button = event.target.querySelector('button');
    if (button.dataset.submitted) { event.preventDefault(); return; }
    // Keep native POST navigation and Shopify's inventory/error handling.
    button.dataset.submitted = 'true';
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.ofj-quick-add button[data-submitted]').forEach(button => {
      delete button.dataset.submitted;
      button.removeAttribute('aria-busy');
      button.textContent = 'Add to cart +';
    });
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ofj-navigation]').forEach(nav => { if (nav._ofjCleanup) nav._ofjCleanup(); });
  });
  setup();
  const top = document.querySelector('[data-ofj-top]');
  if (top) {
    const update = () => { top.hidden = window.scrollY < 700; };
    window.addEventListener('scroll', update, {passive: true});
    top.addEventListener('click', () => {
      window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      const brand = document.querySelector('.ofj-wordmark');
      if (brand) brand.focus({preventScroll:true});
    });
    update();
  }
})();
